/**
 * Native custom event wrapper for a jquery-like api
 * Use native events to allow event hooks to be applied before
 * hub embed initialization if neccesary
 * ex. `window.addEventListener('ufitemsLoaded', someFunc);`
 *  equivelent to `HubsEmbed.Events.on('itemsLoaded', someFunc);`
 * Note: Namespaces cannot contain divider characters such as "." because jquery will not allow it
 */
class Events {
  constructor(namespace, element = window) {
    this.namespace = namespace;
    this.element = element;
  }

  namespaced(eventType) {
    return `${this.namespace}${eventType}`;
  }

  on(eventType, cb) {
    this.element.addEventListener(this.namespaced(eventType), cb);
    return this;
  }

  trigger(eventType, data) {
    const event = new CustomEvent(this.namespaced(eventType));
    Object.assign(event, data);
    this.element.dispatchEvent(event);
    return this;
  }
}

export default Events;
